import React, { useState, useEffect } from "react";

import Select, { components, MenuListProps } from "react-select";

import EmailOptionView from "./options";

import { useDispatch } from "react-redux";
import { searchContactForAutoComplete } from "src/redux/actions/search";

import { localizedStrings } from 'src/localization';

import { fetchIntegrationContacts, fetchIntegrations, invalidateIntegrationContacts } from "src/legacy/redux/actions/integrations";
import { useSelector } from "react-redux";
import IntegrationsService from "src/legacy/services/integrations.service";
import EmailTagView from "./values";

import _ from "lodash";
import cx from "classnames";
import styles from "./autoComplete.module.scss";
import { createContact } from "src/legacy/redux/actions/rolodex";

interface EmailAutoCompleteProps {
  className: string;
  entityType: string;
  inputPlaceholder: string;
  contactSource: string;
  onChange: (token: any) => void;
  value?: any;
  width: string;
}
const EmailAutoComplete: React.FC<EmailAutoCompleteProps> = ({className, entityType, inputPlaceholder, contactSource, onChange, value, width}) => {
  const dispatch = useDispatch();
  const [options, setOptions] = useState<any[]>([]);
  const [query, setQuery] = useState("");
  const [selectedGroup, setSelectedGroup] = useState("");
  const [tags, setTags] = useState(value || []);
  const [inputValue, setInputValue] = useState("");
  const [placeholder, setPlaceholder] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [menuIsOpen, setMenuIsOpen] = useState(false);

  const contacts = useSelector((state: any) => state.search.contacts.items);
  
  const allIntegrations = useSelector((state: any) =>
    _.get(state.legacyRootReducer, "settings.integrations.activated.items"));

  const loaded = useSelector((state: any) =>
    _.get(state.legacyRootReducer, "settings.integrations.activated.loaded"));
  
  const getIntegrations = () => {
    const integrationsList = IntegrationsService.getIntegrations(localizedStrings.components.integrations.integrations);
    return integrationsList.integrations;
  }

  const integrations = allIntegrations
    .filter((item) => {
      const category = _.get(item, "category.id");

      if (category != "crm") {
        return false;
      }

      const masterData = getIntegrations().find((data) => {
        return data.type === item.type;
      });

      return masterData && masterData.searchContacts;
    })
    .map((item) => {
      const masterData = getIntegrations().find((data) => {
        return data.type === item.type;
      });

      return {
        ...item,
        masterData: masterData,
      };
    });

  const integrationSearchResult = useSelector(
    (state: any) => state.legacyRootReducer.rolodex.integrations
  );  

  const getStyles = () => {
    return {
      control: (provided, state) => ({
        ...provided,
        padding: "0.25rem 0rem",
        border: state.isFocused ? 0 : 0,
        boxShadow: state.isFocused ? 0 : 0,
        fontSize: "12px",
        backgroundColor: "$secondary-background-color",
        maxHeight: "6.5rem",
        overflow: "scroll",
        caretColor: contactSource === "generate_link" && _.size(tags)> 0 ? "transparent" : "auto",
        "::-webkit-scrollbar": {
          display: "none !important",
        },
      }),
      input: (provided) => ({
        ...provided,
        padding: 0,
      }),
      valueContainer: (base) => ({
        ...base,
        margin: 0,
        padding: 0,
        backgroundColor: "$secondary-background-color",
      }),
      placeholder: (base) => ({
        ...base,
        fontSize: "12px",
      }),
      indicatorSeparator: (base, state) => ({
        ...base,
        alignSelf: "auto",
      }),
      dropdownIndicator: (base, state) => ({
        ...base,
        display: "none",
      }),
      singleValue: (base, state) => ({
        ...base,

        backgroundColor: "$secondary-background-color",
      }),
      multiValue: (base, state) => ({
        ...base,
        backgroundColor: "$secondary-background-color",
      }),
      multiValueRemove: (base, { data }) => ({
        ...base,
        display: "none",
      }),
      menuList: (base) => ({
        ...base,
        height: "100%",
        minHeight: "4rem",
        maxHeight: "12rem",
        margin: 0,
        padding: 0,
        borderRadius: 10,
        "::-webkit-scrollbar": {
          display: "none !important",
        },
        backgroundColor: "$secondary-background-color",
        "& > :nth-child(2) > :first-child": {
          padding: 0,
        },
      }),
      menu: (base) => ({
        ...base,
        width: width ? width : "100%",
        margin: 0,
        padding: 0,
        backgroundColor: "#fff !important",
        fontSize: "14px",
        borderRadius: 12,
        marginTop: "4px !important",
        marginLeft: contactSource === "quicksend" ? -37 : -10,
        boxShadow : "0px 0px 16px 0px rgba(18, 18, 18, 0.08) !important",
      }),
      option: (base) => ({
        ...base,
        margin: "0 !important",
        padding: "0 !important",
      }),
    };
  };

  const PlaceholderMessage = () => {
    return (
      <div className={styles.placeholderMessage}>{"no contacts found"}</div>
    );
  };

  const MenuOptions: React.FC<any> = ({
    children,
    integrations,
    onTabChange,
    selectedGroup,
    option,
    ...rest
  }) => {
    const [showIntegrations, setShowIntegrations] = useState(false);

    if (_.size(integrations) > 0 && !showIntegrations) {
      setShowIntegrations(true);
    }

    return (
      <components.MenuList {...rest}>
        <div className={styles.menuList}>
          <div>
            {showIntegrations && (
              <div className={styles.groupHeading}>
                <span className={styles.menuListTitle}>Search within:</span>
                <div
                  className={cx("menu-header", styles.tab, {
                    [styles.activeTab]: selectedGroup === "Paperflite",
                  })}
                  onClick={() => {
                    onTabChange("Paperflite");
                  }}
                >
                  Paperflite
                </div>
                {integrations.map((integration) => {
                  return (
                    <button
                      key={integration.type}
                      className={cx(styles.tab, {
                        [styles.activeTab]:
                          selectedGroup === integration.masterData.name,
                      })}
                      onClick={() => onTabChange(integration)}
                    >
                      {integration.masterData.name}
                    </button>
                  );
                })}
              </div>
            )}
          </div>
        </div>
        <div className={styles.children}>{children}</div>
      </components.MenuList>
    );
  };
  
    const processContacts = (contacts) => {
      if (_.size(contacts) === 0) {
        return [];
      }
  
      return contacts
        .filter((contact) => {
          if (tags) {
            var index = tags.findIndex((tag: {type: string, value: any, groupName: string}) => {
                if (tag.type == "contact") {
                    if(tag?.groupName === selectedGroup){ // Check for selected group to prevent cross selection for same contact in different groups
                    if (tag.value?.id && contact.id) {  // valid IDs on both sides, compare by ID
                        return tag.value.id === contact.id;
                    }

                    if (tag.value?.email && contact.email) { // fallback, compare by email if ID is null
                        return tag.value.email === contact.email;
                    }
                  } else {
                    return false;
                  }
                } else if (tag.type == "email") {
                  return tag.value == contact.email;
                } 
            });
            return index == -1;
          }
          return true;
        })
        .map((contact, index) => {
          return {
            value: contact,
            label:
              contact.entityType == "contact"
                ? `${contact.firstName ? contact.firstName : ""} ${
                    contact.lastName ? contact.lastName : ""
                  }`
                : contact.name,
            type: contact.entityType,
            valid: true,
            name: "Paperflite",
            isFocused: index == 0 ? true : false
          };
        });
    };

  const populateOptions = () => { // merge the paperflite contacts & integration contacts with groups
   
    if(_.isEmpty(tags) && _.size(query) === 0){ // If no query & no tags, return empty options
      setMenuIsOpen(false);
      return [];
    }

    const hasIntegrations = _.size(integrations) > 0;

    if (!hasIntegrations) {
      return processContacts(contacts);
    }

    var options = processContacts(contacts);

    var groups = [
      {
        type: "option_group",
        label: "Paperflite",
        source: "paperflite",
        options: options,
        selected: selectedGroup === "paperflite",
      },
    ];

    integrations.forEach((integration) => {
      var integrationOption = {
        type: "option_group",
        label: integration.masterData.name,
        source: integration.masterData.type,
        integration: integration,
        selected: selectedGroup === integration.masterData.type,
        options: [
          {
            type: "option_group",
            label: "empty",
            fetching: true,
            fetched: false,
            empty: false,
            value: "Searching",
            name: integration.masterData.type,
          },
        ],
      };
      if (integrationSearchResult.id === integration.id) {
        const searching = integrationSearchResult.searching;
        const items = integrationSearchResult.items;
        const fetched = integrationSearchResult.fetched;
        if (fetched) {
          var options = processContacts(items);
          if (options.length == 0) {
            options = [
              {
                type: "option_group",
                label: "empty",
                fetching: searching,
                fetched: fetched,
                empty: true,
                value: "No results found",
                name: integration.masterData.type,
              },
            ];
          }
          integrationOption = {
            ...integrationOption,
            options: options,
          };
        }
      }
      groups = [...groups, integrationOption];
    });

    return groups;
  };  

  const handleInputChange = (value) => {
    const query = value.trim();

    if (query.length <= 1) {
      setQuery("");
    } else {
      setQuery(query);
      
      var group = options.filter(
        (option: any) => option.label == selectedGroup,
      ) as any[];

      if (selectedGroup === "Paperflite") {
        dispatch(invalidateIntegrationContacts());
        dispatch(searchContactForAutoComplete({ query, type: entityType }));
      }else if (!_.isEmpty(_.get(group[0], "integration.id"))) {
       dispatch<any>(fetchIntegrationContacts(group[0].integration.id, query, 0))
       .then(() => populateOptions());
      }

      setIsLoading(true);
      if (_.size(query) > 2 && !menuIsOpen) {
        setMenuIsOpen(true);
      }
    }
 
    return value;
  };
  
  const handleGroupSelection = (group) => {
    const selectedGroup = _.get(group, "masterData.name", "Paperflite");
    setSelectedGroup(selectedGroup);
    window.localStorage.setItem("crm", selectedGroup);
    (dispatch as any)(fetchIntegrationContacts(group.id, query, 0)).then(
      populateOptions(),
    );
  };  

  const handleCreateTag = (newTag) => {
    if (!Array.isArray(newTag)) {
      newTag = [newTag];
    }

    const newTags = _.differenceWith(newTag, tags);
    if (newTags) {
      newTags
        .filter((option) => {
          const source = _.get(option, "group.source") || "paperflite";
          return source !== "paperflite";
        })
        .forEach((option) => {
          let request: any = {
            email: _.get(option, "value.email"),
            firstName: _.get(option, "value.firstName"),
            lastName: _.get(option, "value.lastName"),
            company: _.get(option, "value.company"),
            workPhone: _.get(option, "value.workPhone"),
            sources: [
              {
                type: _.get(option, "value.sources[0]"),
              },
            ],
          };

          if (!_.isNull(contactSource)) {
            request = {
              ...request,
              sources: [...request.sources, { type: contactSource }],
            };
          }

        });
    }

    setTags((prevTags) => {
      const updatedTags = [...prevTags, ...newTags];

      if (onChange) {
        onChange(updatedTags);
      }

      return updatedTags;
    });
    setInputValue("");
    setIsLoading(false);
  };

  const isValidEmail = (email) => {
    if (!email) {
      return false;
    }

    var re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  const handleCreateNewOption = (value) => {
    var pattern = ",|;|'";

    var regex = new RegExp(pattern);
    var email = value.split(regex).join("");

    var newTag = {
      label: email,
      value: email,
      valid: true,
      type: "email",
    };

    handleCreateTag(newTag);
  };

  const shouldKeyDownEventCreateNewOption = (e) => {
    const keyCode = e.keyCode;
    const value = e.target.value;
    const isValid = isValidEmail(value);

    switch (keyCode) {
      case 13: // ENTER
        if(isValid){
          handleCreateNewOption(value);
          setMenuIsOpen(false); // close menu on enter
        }
        break;
        
      case 8: //BACKSPACE
        if (tags.length > 0 && e.target.value == 0) {
          const allTags = [...tags];
          const selectedTags = allTags.slice(0, allTags.length - 1);
          setTags(selectedTags);
          onChange(selectedTags);
          if(_.size(selectedTags) === 0){
            setMenuIsOpen(false); // close menu if no tags
          }   
        }
        break;
    }
  };

  const handleBlur = (e) => {
    const value = e.target.value;
    const inputValues = value.split(/[,\s;]+/);

    inputValues.forEach((inputValue) => {
      if (inputValue) {
        const pattern = ",|;|'";

        const regex = new RegExp(pattern);
        const label = inputValue.split(regex).join("");
        const value = inputValue.replace(/[<>]/g, "");

        if (isValidEmail(value)) {
          const newTag = {
            label: label,
            value: value,
            valid: true,
            type: "email",
          };

          handleCreateTag(newTag);
        }
      }
      setMenuIsOpen(false);
      setIsLoading(false);
    });

    if (_.size(query) == 0 && inputPlaceholder) {
      setPlaceholder(inputPlaceholder);
    }
  };

  const onNewOptionClick = (option) => {

    var newTag = {
      label: option.name,
      value: option,
      valid: true,
      type: option.entityType,
      groupName: selectedGroup
    };

    if(canCreateContact(option)){
      createContactForRequest(option);
    }
    handleCreateTag(newTag);
  };

  const canCreateContact = (option) => {
    return _.get(option, "sources[0]", false);
  }

  const createContactForRequest = (option) => {
   
    var request = {
      email: _.get(option, "email"),
      firstName: _.get(option, "firstName"),
      lastName: _.get(option, "lastName"),
      sources: [
        {
          type: _.get(option, "sources[0]"),
        },
      ],
    };

    dispatch<any>(createContact(request));

  }  

  const onRemove = (value) => {
    const selectedTags = tags.filter(
      (tag: any) => tag.value.id != value.id || tag.value != value
    );

    setTags(selectedTags);
    onChange(selectedTags);
  };

  useEffect(() => {
    if (_.size(allIntegrations) === 0 && !loaded) {
      (dispatch as any)(fetchIntegrations());
    }
    if (!_.isEqual(inputPlaceholder, placeholder)) {
      setPlaceholder(placeholder);
    }
  }, [allIntegrations,loaded ]);  
  

  useEffect(() => {
    const validOptions = populateOptions();

    if (!_.isEqual(options, validOptions)) {
      setOptions(validOptions);
    }
    setIsLoading(false);
  }, [contacts]);

  
  useEffect(() => {
    var groupName =  (window.localStorage.getItem('crm')) || "Paperflite";
    setSelectedGroup(groupName);
    
    var group = integrations.filter((integration) => _.get(integration, 'masterData.name') == groupName)

    if(_.isEmpty(group)){
      setSelectedGroup("Paperflite") 
    }

    var newOptions = populateOptions();
    if (!_.isEqual(options, newOptions)) {
      setOptions(newOptions);
      setIsLoading(false);
    }

  }, [integrations]);  

  return (
    <div className={cx(styles.emailContainer)}>
      <Select
        menuIsOpen={menuIsOpen}
        isClearable={false}
        isMulti={contactSource === "quicksend" ? true : false}
        placeholder={placeholder}
        isLoading={isLoading}
        loadingMessage={() => "Loading...."}
        options={
          _.size(integrations) > 0
            ? options.filter((option: any) => option.label == selectedGroup)
            : options
        }
        filterOption={(option: any, input: string) => {
          return option;
        }}
        inputValue={inputValue}
        value={tags}
        styles={getStyles()}
        onKeyDown={shouldKeyDownEventCreateNewOption}
        components={{
          Menu: (props) => (
            <div className="customMenu">
            <components.Menu {...props} />
            </div>
          ),
          Option: ({ data }) => {
            return (
              <EmailOptionView
                option={data}
                key={data.label}
                setValue={onNewOptionClick}
              />
            );
          },
          MenuList: (props, option) => (
            <div className={styles.menuListOptions}>
              <MenuOptions
                {...props}
                option={option}
                integrations={integrations}
                selectedGroup={selectedGroup}
                onTabChange={(group) => handleGroupSelection(group)}
              />
            </div>
          ),
          GroupHeading: () => null,
          NoOptionsMessage: () => <PlaceholderMessage></PlaceholderMessage>,
        }}
        onInputChange={(value, action) => {
          handleInputChange(value);
          if (action.action == "input-change") {
            setInputValue(value);
          }
        }}
        formatOptionLabel={(option) => (
          <EmailTagView
            option={{ ...option, valid: option.valid ?? true }} 
            onRemove={onRemove}
          />
        )}
        onBlur={handleBlur}
      />
    </div>
  );
};

export default EmailAutoComplete;
